"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.OFFSET_CALCULATORS = {
    x: (_a = {},
        _a[types_1.X_AXIS.outsideLeft] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.left - popoverRect.width - portalPosition.left + offset.left;
        },
        _a[types_1.X_AXIS.outsideRight] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.left + targetRect.width - portalPosition.left + offset.left;
        },
        _a[types_1.X_AXIS.middle] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.left +
                targetRect.width / 2 -
                popoverRect.width / 2 -
                portalPosition.left +
                offset.left);
        },
        _a[types_1.X_AXIS.insideLeft] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.left - portalPosition.left + offset.left;
        },
        _a[types_1.X_AXIS.insideRight] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.left +
                targetRect.width -
                popoverRect.width -
                portalPosition.left +
                offset.left);
        },
        _a),
    y: (_b = {},
        _b[types_1.Y_AXIS.outsideTop] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.top - popoverRect.height - portalPosition.top + offset.top;
        },
        _b[types_1.Y_AXIS.outsideBottom] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.top + targetRect.height - portalPosition.top + offset.top;
        },
        _b[types_1.Y_AXIS.middle] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.top +
                targetRect.height / 2 -
                popoverRect.height / 2 -
                portalPosition.top +
                offset.top);
        },
        _b[types_1.Y_AXIS.insideTop] = function (_a) {
            var targetRect = _a.targetRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return targetRect.top - portalPosition.top + offset.top;
        },
        _b[types_1.Y_AXIS.insideBottom] = function (_a) {
            var targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
            return (targetRect.top +
                targetRect.height -
                popoverRect.height +
                -portalPosition.top +
                offset.top);
        },
        _b)
};
//# sourceMappingURL=calculators.js.map